import { gql } from "@apollo/client";

export const INGESTION_STATUS = gql`
  query IngestionStatus($limit: Int) {
    ingestionStatus(limit: $limit) {
      id
      startedAt
      completedAt
      windowStart
      windowEnd
      factsCreated
      status
      errorMessage
    }
  }
`;

export const PERFORMANCE_SUMMARY = gql`
  query PerformanceSummary($filter: PerformanceFilter!) {
    performanceSummary(filter: $filter) {
      role
      totalUsers
      totalDocuments
      totalFields
      totalDatapoints
      totalCorrect
      totalErrors
      performancePercent
      windowStart
      windowEnd
    }
  }
`;

export const PERFORMANCE_DETAILS = gql`
  query PerformanceDetails(
    $filter: PerformanceFilter!
    $first: Int
    $after: String
  ) {
    performanceDetails(filter: $filter, first: $first, after: $after) {
      edges {
        cursor
        node {
          personId
          personName
          personEmail
          orgId
          totalDocuments
          totalFields
          totalDatapoints
          totalErrors
          performancePercent
          scorePerformance
          errorBreakdown {
            errorType
            total
            percentage
            documentsAffected
            fieldsAffected
          }
          ... on AnalystPerformance {
            workDays
          }
          ... on ReviewerPerformance {
            reviewDays
            avgReviewTimeMinutes
          }
        }
      }
      pageInfo {
        hasNextPage
        hasPreviousPage
        startCursor
        endCursor
      }
      totalCount
    }
  }
`;

export const FILTER_OPTIONS = gql`
  query FilterOptions($orgId: ID!) {
    filterOptions(orgId: $orgId) {
      documents {
        id
        name
        type
      }
      fields {
        id
        name
        displayName
        type
        category
      }
      classifications
      analysts {
        id
        name
        email
      }
      reviewers {
        id
        name
        email
      }
      minDate
      maxDate
    }
  }
`;

export const PRODUCTIVITY_TRENDS = gql`
  query ProductivityTrends($filter: TimeFilter!) {
    productivityTrends(filter: $filter) {
      groupBy
      points {
        date
        fieldsCompleted
        datapointsCompleted
        documentsCompleted
      }
    }
  }
`;

export const ERROR_ANALYSIS = gql`
  query ErrorAnalysis($personId: ID!, $filter: EvaluationFilter!) {
    errorAnalysis(personId: $personId, filter: $filter) {
      personId
      errorBreakdown {
        errorType
        total
        percentage
        documentsAffected
        fieldsAffected
      }
      affectedDocuments {
        id
        name
        type
        companyName
      }
      totalErrors
      lastActiveAt
    }
  }
`;

export const EVALUATIONS = gql`
  query Evaluations($filter: EvaluationFilter!, $first: Int, $after: String) {
    evaluations(filter: $filter, first: $first, after: $after) {
      edges {
        cursor
        node {
          id
          role
          value
          previousValue
          finalValue
          isFinal
          classification
          classificationReason
          classificationConfidence
          submittedAt
          classifiedAt
          document {
            id
            name
            type
            companyName
          }
          field {
            id
            name
            displayName
          }
          datapoint {
            id
            name
            displayName
          }
          person {
            id
            name
          }
        }
      }
      pageInfo {
        hasNextPage
        endCursor
      }
      totalCount
    }
  }
`;

export const RUN_INGESTION = gql`
  mutation RunIngestion($input: IngestionInput!) {
    runIngestion(input: $input) {
      success
      runId
      mode
      windowStart
      windowEnd
      factsCreated
      duration
      status
      errorMessage
      dryRun
      estimatedRecords
    }
  }
`;

export const RUN_CLASSIFICATION = gql`
  mutation RunClassification($input: ClassificationInput!) {
    runClassification(input: $input) {
      success
      total
      classified
      failed
      chunks
      byType {
        type
        count
      }
      dryRun
      errorMessage
    }
  }
`;
